// @ts-nocheck
import React, { useEffect, useState } from 'react'
import { usePlacesWidget } from 'react-google-autocomplete'
import SearchField from './SearchField'
import { ADDRESS_ATTRIBUTES, GOOGLE_MAPS_BASE_URL, GOOGLE_MAPS_AUTOCOMPLETE_OPTIONS } from 'utils/constants'
import { geoCode } from 'utils/googleMapsUtils/googleMapsUtils'

const SearchStore = ({ apiKey, region, conversationText, onPlaceSelected, onSearchReset, selectedPlace, setIsSearchStoreMounted }) => {
	const { ref } = usePlacesWidget({
		apiKey,
		googleMapsScriptBaseUrl: GOOGLE_MAPS_BASE_URL,
		onPlaceSelected,
		options: {
			types: GOOGLE_MAPS_AUTOCOMPLETE_OPTIONS,
			fields: ADDRESS_ATTRIBUTES,
			componentRestrictions: { country: region || '' },
		},
	})

  // it's temporary fix - need to check how to handle both google places and map when loading together
	if (ref.current) {
		setTimeout(() => {
			setIsSearchStoreMounted(true)
		}, 400)
	}

	const onSuggestedItemEnterPressed = async (textValue) => {
		try {
			const geoCodeRes = await geoCode({
				address: textValue,
				componentRestrictions: { country: region },
			}, apiKey)
			if (geoCodeRes) {
				await onPlaceSelected(geoCodeRes)
			}
		} catch (err) {
			console.error(err)
		}
	}

	return (
		<div>
			<SearchField
				inputRef={ref}
				conversationText={conversationText}
				selectedPlace={selectedPlace}
				onSearchReset={onSearchReset}
				onSuggestedItemEnterPressed={onSuggestedItemEnterPressed}
			/>
		</div>
	)
}

export default SearchStore
